import React from 'react';
import './CeremonyCard.css';

const CeremonyCard = ({ image, title, description }) => {
    return (
        <div className="ceremony-card">
            <img src={image} alt={title} className="ceremony-image" />
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    );
};

export default CeremonyCard;
